<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { onBeforeMount } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"

// ================================
// COMPOSABLES
// ================================
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

// ================================
// LIFECYCLE
// ================================
onBeforeMount(() => {
    authStore.logout()
    const id = route.params._id_user
    if (id === "undefined" || !id) {
        router.push("/login")
    }
})
</script>

<template>
    <!-- ================================ -->
    <!-- PAGE CONTAINER -->
    <!-- ================================ -->
    <div class="page page-login flex justify-center items-center min-h-screen">
        <div class="w-full max-w-2xl mx-4">
            <FormAuthValidation class="p-8" />
        </div>
    </div>
</template>
